import { db } from "app/firebaseInit";
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc } from 'firebase/firestore';

// Yazarlar listesini Firestore'dan al ve cache'e kaydet
export const fetchAuthorsFromFirestore = async () => {
    try {

        const snapshot = await getDocs(collection(db, 'authors'));
        const authorsData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

        // Yazarlar listesini tarayıcıda saklayın (localStorage örneği)
        // localStorage.setItem('authors', JSON.stringify(authorsData));

        return authorsData;
    } catch (error) {
        console.error("Error fetching authors:", error);
        throw new Error("An error occurred while retrieving the authors list.");
    }
};

// Yazar ekleme
export const addAuthorToFirestore = async (name) => {
    try {
        await addDoc(collection(db, 'authors'), { name });
    } catch (error) {
        console.error("Error adding author:", error);
        throw new Error("An error occurred while adding the author.");
    }
};

// Yazar güncelleme
export const updateAuthorInFirestore = async (id, name) => {
    try {
        const ref = doc(db, 'authors', id);
        await updateDoc(ref, { name });
    } catch (error) {
        console.error("Error updating author:", error);
        throw new Error("An error occurred while updating the author.");
    }
};

// Yazar silme
export const deleteAuthorFromFirestore = async (id) => {
    try {
        const ref = doc(db, 'authors', id);
        await deleteDoc(ref);
    } catch (error) {
        console.error("Error deleting author:", error);
        throw new Error("An error occurred while deleting the author.");
    }
};

// Cache'ten yazarlar listesini al
export const getAuthorsFromCache = () => {
    const cachedAuthors = JSON.parse(localStorage.getItem('authors'));
    return cachedAuthors || [];
};

// Cache'i güncelle
export const updateCacheWithAuthors = (authors) => {
    // localStorage.setItem('authors', JSON.stringify(authors));
};

export const getAuthors = async () => {
    // const cachedAuthors = getAuthorsFromCache(); // Cache kontrolü
    // if (cachedAuthors.length > 0) {
    //     return cachedAuthors.map(author => ({
    //         label: author.name, // label olarak yazar adı
    //         value: author.id, // value olarak yazar ID'si
    //     }));
    // } else {
    const authorsFromFirestore = await fetchAuthorsFromFirestore(); // Firestore'dan çek
    const authorsList = authorsFromFirestore.map(author => ({
        label: author.name,
        value: author.id,
    }));
    // updateCacheWithAuthors(authorsFromFirestore); // Cache güncelle
    return authorsList;
    // }
};

